import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CompanyModel } from '../../models/Company';

interface CompaniesState {
  companies: CompanyModel | null;
}

const initialState: CompaniesState = {
  companies: null,
};

const companiesSlice = createSlice({
  name: 'companies',
  initialState,
  reducers: {
    setCompanies(state, action: PayloadAction<CompanyModel>) {
      state.companies = action.payload;
    },
    updateCompanies(state, action: PayloadAction<CompanyModel>) {
      state.companies = { ...action.payload };
    },
    clearCompanies(state) {
      state.companies = null;
    }
  }
});

export const { setCompanies, updateCompanies, clearCompanies } = companiesSlice.actions;

export default companiesSlice.reducer;
